var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPrivacy32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.53 5.47a.75.75 0 010 1.06L11.791 21.27a.744.744 0 01-.134.133L6.53 26.53a.75.75 0 01-1.06-1.06l4.555-4.556c-1.183-.894-2.714-2.379-4.577-4.403a.75.75 0 01-.034-.976C8.804 11.295 12.33 9 16 9c1.583 0 3.145.43 4.68 1.26l4.79-4.79a.75.75 0 011.06 0zm-6.963 5.903c-1.21-.589-2.396-.873-3.567-.873-2.872 0-5.877 1.721-9.006 5.472 1.767 1.892 3.13 3.167 4.103 3.87l2.136-2.136a3.25 3.25 0 014.473-4.473l1.86-1.86zm-2.979 2.978l-2.237 2.237a1.75 1.75 0 012.237-2.237z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.208 13.213a.75.75 0 011.06-.024 54.65 54.65 0 012.276 2.298.75.75 0 01.041.985C23.195 20.708 19.67 23 16 23c-.23 0-.461-.01-.691-.027a.75.75 0 01.118-1.496c.19.015.382.023.573.023 2.87 0 5.873-1.718 9-5.46a48.848 48.848 0 00-1.762-1.76l-.006-.006a.75.75 0 01-.024-1.06z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrivacy32);
export default __webpack_public_path__ + "static/media/icon-privacy-32.12baf877.svg";
export { ForwardRef as ReactComponent };